import { TrendingUp, Users, Gift, LucideIcon } from "lucide-react";

interface TimelineCardEnProps {
  age: string;
  moment: string;
  icon: LucideIcon;
  description: string;
  emotionalValue: string;
  contributionsReceived: string;
  contributors: number;
  totalInvested: string;
  totalFuture: string;
  growth: string;
  index: number;
}

const TimelineCardEn = ({
  age,
  moment,
  icon: Icon,
  description,
  emotionalValue,
  contributionsReceived,
  contributors,
  totalInvested,
  totalFuture,
  growth,
  index,
}: TimelineCardEnProps) => {
  return (
    <div
      className="w-[340px] md:w-[400px] bg-white rounded-3xl shadow-xl overflow-hidden transform hover:scale-105 transition-all duration-300"
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {/* Age Badge */}
      <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white text-center py-3 font-bold text-lg">
        {age}
      </div>

      {/* Header */}
      <div className="relative p-6 bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50">
        <div className="flex items-center gap-4 mb-3">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 flex items-center justify-center shadow-lg">
            <Icon className="h-7 w-7 text-white" />
          </div>
          <h3 className="text-2xl font-bold">{moment}</h3>
        </div>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Contributions Info */}
        <div className="bg-sunrise-light/30 p-4 rounded-lg">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div className="flex-1">
              <p className="text-sm font-medium mb-1">💝 Moment-savings created</p>
              <div className="flex items-center gap-1 text-xs text-muted-foreground">
                <Users className="h-3 w-3" />
                <span>{contributors} loved ones</span>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-bold text-primary">{contributionsReceived}</p>
            </div>
          </div>
          
          <div className="bg-white/60 p-3 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">💭 Emotional value:</p>
            <p className="text-sm italic">{emotionalValue}</p>
          </div>
        </div>

        {/* Financial Summary */}
        <div className="bg-legatia-green/10 p-4 rounded-xl border border-legatia-green/20">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-semibold">Total invested:</span>
            <span className="text-lg font-bold text-primary">{totalInvested}</span>
          </div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-semibold">Value at 18:</span>
            <span className="text-lg font-bold text-growth">{totalFuture}</span>
          </div>
          <div className="flex items-center justify-center gap-2 mt-2 pt-2 border-t border-legatia-green/20">
            <TrendingUp className="h-4 w-4 text-growth" />
            <span className="text-sm font-bold text-growth">{growth} growth</span>
          </div>
        </div>

        {/* With Legatia */}
        <div>
          <p className="text-sm font-semibold text-muted-foreground mb-2">With Legatia:</p>
          <div className="space-y-1">
            <p className="text-sm">📸 Preserved memories forever</p>
            <p className="text-sm">💰 Money invested and growing</p>
            <p className="text-sm">🎁 Ready at age 18</p>
          </div>
        </div>

        {/* Badge */}
        <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white text-center py-2 px-4 rounded-full font-bold">
          Memory + Capital
        </div>
      </div>
    </div>
  );
};

export default TimelineCardEn;
